import { get } from 'lodash';
import { instance } from './api.service';
import conf from '../../config';

export const syncQuickbooks = async () => {
  const resp = await instance.get(`/quick/comparecustomers`, { data: {} });
  return get(resp, 'data.data', []);
};

export const createInvoice = async (data) => {
  const resp = await instance.post(`/quick/createInvoice`, data);
  return get(resp, 'data.data', []);
};

export const getQuickbooksAuthUrl = () => {
  const { url } = conf();
  return `${url}/api/quick/auth`;
};
